import './munis-map/munis-map.tag'
import './munis-map/munis-map-legend.tag'
import './map-infobox/map-infobox.tag'
import './map-searchbox/map-searchbox.tag'

riot.tag2('cor-mj-munis-map', '<map-searchbox ref="searchbox"></map-searchbox> <map-infobox ref="infobox" config="{opts.config}"></map-infobox> <munis-map ref="munis-map"></munis-map> <munis-map-legend ref="munis-map-legend"></munis-map-legend>', '', 'class="{getClass(\'app-wrapper\')}"', function(opts) {
});



// WEBPACK FOOTER //
// ./src/components/app.tag